import $ from 'jquery';
import intlTelInput from 'intl-tel-input';
import { countryTranslations as countryNames } from 'intl-tel-input/i18n/en';
import 'select2';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

const cmd = {
	activ: false,
	header_height: 0,
	bottom_position: 0,
	recap_width: 0,
	step: 0,
	iti: null,
	securitycode: document.getElementById('_card_ccv'),
	expirationdate: document.getElementById('_card_expiry'),
	cardnumber: document.getElementById('_card_number'),

	init() {
		this.activ = true;
		this.recap_width = $("._ophorus_cmd_recap").width();
		this.header_height = $(".__ophorus_header").height();

		const $summary = $("._contain_summary");
		if ($summary.length) {
			this.bottom_position = $summary.offset().top + $summary.height();
		}

		if (document.querySelector("#_p_phone")) {
			const input = document.querySelector("#_p_phone");
			this.iti = intlTelInput(input, {
				initialCountry: "auto",
				geoIpLookup: function (success, failure) {
					fetch("https://ipapi.co/json")
						.then(res => res.json())
						.then(data => success(data.country_code.toLowerCase()))
						.catch(() => success("us")); // fallback États-Unis
				},
				showSelectedDialCode: true,
				loadUtils: () => import("intl-tel-input/build/js/utils.js"),
				excludeCountries: ["ax", "as"] // adapte selon tes besoins
			});
		}

		this.buildCountrySelect();

		$("._ophorus_cmd_recap").css("width", this.recap_width);

		this.checkavaibility();

		// RESUME MOBILE COMPACT (cf. cmd_booking_recap.php / _ophorus_cmd_recap.scss) -
		// slideDown/slideUp plutot qu'un simple toggle de classe CSS pour une
		// animation fluide, coherent avec l'accordeon principal de la page.
		$(document).on("click", "._recap_compact_toggle", function () {
			const $btn = $(this);
			const $panel = $("#_recap_full_detail");
			const expanded = $btn.attr("aria-expanded") === "true";

			$panel.stop(true, true)[expanded ? "slideUp" : "slideDown"](300);
			$btn.attr("aria-expanded", (!expanded).toString());
			$btn.find("._recap_compact_label_text").text(expanded ? "View booking details" : "Hide booking details");
			$btn.find(".__arrow").toggleClass("_down", expanded).toggleClass("_up", !expanded);
		});

		// CODE PROMO - accordeon independant (cf. cmd_booking_recap.php
		// ._promo_toggle), meme pattern slideDown/slideUp que le toggle
		// booking details ci-dessus mais actif a toutes les tailles d'ecran.
		$(document).on("click", "._promo_toggle", function () {
			const $btn = $(this);
			const $panel = $("#_promo_full_detail");
			const expanded = $btn.attr("aria-expanded") === "true";

			$panel.stop(true, true)[expanded ? "slideUp" : "slideDown"](300);
			$btn.attr("aria-expanded", (!expanded).toString());
			$btn.find(".__arrow").toggleClass("_down", expanded).toggleClass("_up", !expanded);

			// Le libelle "Promo code applied" (code deja valide) reste fixe -
			// seul le libelle "Add a promo code" / "Hide promo code" (pas encore
			// de code) bascule selon l'etat ouvert/ferme.
			const $label = $btn.find("._promo_toggle_label");
			if ($label.text() !== "Promo code applied") {
				$label.text(expanded ? "Add a promo code" : "Hide promo code");
			}
		});

		// Le panneau garde le style inline pose par slideDown/slideUp meme apres
		// un redimensionnement : sans ce reset, passer sous puis au-dessus du
		// seuil mobile/desktop (rotation, resize navigateur) peut laisser le
		// recap sticky desktop cache par un "display: none" herite du mobile.
		this.recapBreakpoint = 992;
		this.recapWasMobile = window.innerWidth <= this.recapBreakpoint;

		// CODE PROMO EN MOBILE : sa propre carte separee (cf. retours
		// utilisateur), plutot qu'a l'interieur de la carte "Your booking"
		// comme en desktop. On deplace le meme noeud DOM (pas de duplication
		// de formulaire) au lieu d'insertBefore/After bases sur sa position
		// precedente : toujours ancre sur #_recap_full_detail, donc
		// idempotent quel que soit le nombre d'allers-retours mobile/desktop.
		this.togglePromoRecapPosition = (isMobile) => {
			const $promo = $("#_promo_recap_block");
			const $anchor = $("#_recap_full_detail");
			if (!$promo.length || !$anchor.length) return;

			if (isMobile) {
				$promo.addClass("_detached").insertAfter($(".col-12._contain_recap"));
			} else {
				$promo.removeClass("_detached").insertAfter($anchor);
			}
		};
		this.togglePromoRecapPosition(this.recapWasMobile);

		$(window).on("resize", () => {
			const isMobile = window.innerWidth <= this.recapBreakpoint;
			if (isMobile === this.recapWasMobile) return;
			this.recapWasMobile = isMobile;
			$("#_recap_full_detail").removeAttr("style");
			const $toggle = $("._recap_compact_toggle").attr("aria-expanded", "false");
			$toggle.find("._recap_compact_label_text").text("View booking details");
			$toggle.find(".__arrow").addClass("_down").removeClass("_up");

			this.togglePromoRecapPosition(isMobile);
		});

		$(document).on("click", "._refresh_page", () => location.reload());

		// CONFIRMATION AVANT SUPPRESSION D'UN PRODUIT (Booking details) - le
		// lien "Remove" ne pointe plus directement vers delete-product/{id},
		// il ouvre cette modale ; le lien de confirmation a l'interieur porte
		// la vraie URL et navigue normalement une fois clique (meme route
		// qu'avant, aucun changement cote serveur).
		$(document).on("click", ".__remove_product_trigger", (e) => {
			e.preventDefault();
			const $trigger = $(e.currentTarget);
			$("#__remove_confirm_modal .__remove_confirm_name").text($trigger.data("removeName") || "this tour");
			$("#__remove_confirm_modal .__remove_confirm_ok").attr("href", $trigger.data("removeUrl"));
			$("#__remove_confirm_modal").addClass("__show").css("display", "flex");
		});

		$(document).on("click", ".__remove_confirm_cancel", () => {
			$("#__remove_confirm_modal").removeClass("__show").hide();
		});

		// Clic sur le fond assombri (pas sur la carte elle-meme) = annuler.
		$(document).on("click", "#__remove_confirm_modal", (e) => {
			if (e.target === e.currentTarget) {
				$("#__remove_confirm_modal").removeClass("__show").hide();
			}
		});

		$(document).on("keydown", (e) => {
			if (e.key === "Escape") {
				$("#__remove_confirm_modal").removeClass("__show").hide();
			}
		});

		$("._section_cmd._activ .__content_cmd").slideDown(600);

		// ETAPE SUIVANTE (bouton "Continue" de chaque section)
		$(document).on("click", "._ophorus_btn_order", (e) => {
			const $btn = $(e.currentTarget);
			// "_refresh_page" (modale produit indisponible) reutilise la meme
			// classe visuelle mais n'a pas de data-step : rien a faire ici.
			if (!$btn.data("step") && $btn.data("step") !== 0) return;

			let _step = parseInt($btn.data("step"), 10);
			const billing = $btn.data("stepBilling") === true || $btn.data("stepBilling") === "true";
			const infos = $btn.data("stepInfos") === true || $btn.data("stepInfos") === "true";
			let _continue = true;

			if (billing) _continue = this.checkBilling();
			if (infos) _continue = this.checkInfos();

			if (_continue) {
				this.openStep(_step + 1, {focusField: true});
			}
		});

		// REOUVERTURE D'UNE ETAPE VALIDEE (bouton "Edit" / en-tete cliquable -
		// le bouton est natif <button disabled> tant que l'etape n'est pas
		// COMPLETED, donc aucun clic ne peut arriver ici pour une etape FUTURE
		// ou deja ACTIVE).
		$(document).on("click", ".__step_trigger", (e) => {
			const $section = $(e.currentTarget).closest("._section_cmd");
			if (!$section.hasClass("_validate")) return;

			this.openStep(parseInt($section.data("step"), 10), {focusField: true});
		});

		$(document).on("focus", "._error_required", function () {
			$(this).removeClass("_error_required");
			$(this).parent().find("._error_msg").remove();
			$(this).closest("._section_cmd").removeClass("_error");
		});

		$(document).on("click", "__open_form_code", () => {
			$(".__form_promotion").toggleClass("_open");
			$("._unvalid").hide();
			$(".__open_form_code").toggle($(".__form_promotion").hasClass("_open") === false);
		});

		$(document).on("click", "._close_promo", () => {
			$(".__form_promotion").removeClass("_open");
			$(".__open_form_code").css("display", "block");
			$("._unvalid").hide();
		});

		$(document).on("click", "._btn_close_modal", () => $(".__modal_error").remove());

		$(document).on("click", ".__bnt_order", (e) => {
			if (!$("#_card_cgv").prop("checked")) {
				alert("You must agree to the Terms & Conditions before proceeding.");
				e.preventDefault();
				return;
			}
			$("._background_wait").find("span").html("You are being redirected to the payment module after verifying your cart. <br> Please wait...");
			$("._background_wait").addClass("_cmd").show();
		});
	},

	// ////////////////////////////////////////////////////////////////////
	// ETATS DE L'ACCORDEON (ACTIVE / COMPLETED / FUTURE / ERROR)
	// ////////////////////////////////////////////////////////////////////

	// Applique l'etat visuel + aria-expanded/disabled sur une section donnee.
	// "validate" = COMPLETED (repliee, resume, reouvrable) / "active" = ACTIVE
	// (ouverte) / "future" = pas encore atteinte.
	setStepState($section, state) {
		const $trigger = $section.find(".__step_trigger").first();

		$section.removeClass("_activ _validate");
		if (state === "validate") $section.addClass("_validate");
		if (state === "active") $section.addClass("_activ");

		$trigger.attr("aria-expanded", state === "active" ? "true" : "false");
		$trigger.prop("disabled", state !== "validate");
	},

	// Ouvre l'etape "step" : replie la section active courante (si elle
	// existe et n'est pas celle qu'on ouvre deja), l'ouvre avec un scroll
	// fluide, et deplace le focus clavier sur son premier champ le cas
	// echeant.
	openStep(step, {focusField = false} = {}) {
		const $target = $(`._section_cmd[data-step='${step}']`);
		if (!$target.length) return;

		$("._section_cmd._activ").not($target).each((i, el) => {
			const $el = $(el);
			// Le paiement (Stripe) ne devient jamais "COMPLETED" dans cette
			// page - repasser dessus le remet dans son etat neutre plutot que
			// de lui afficher un resume vide + une coche.
			if ($el.find(".__payment").length) {
				this.setStepState($el, "future");
			} else {
				this.refreshStepSummary($el);
				this.setStepState($el, "validate");
				this.playMicroAnim($el.find("._num").get(0), "__pulse_anim");
				this.playMicroAnim($el.find(".__step_summary").get(0), "__summary_reveal");
			}
		}).find(".__content_cmd").slideUp(400);

		this.setStepState($target, "active");

		const $content = $target.find(".__content_cmd");
		$content.slideDown(600, () => {
			this.playMicroAnim($content.get(0), "__reveal_anim");
			gsap.to(window, {
				duration: 1,
				scrollTo: {y: $target, offsetY: 100}
			});
			if (focusField) {
				$content.find("input:not([type=hidden]), select, textarea, button").not("[disabled]").first().trigger("focus");
			}
		});

		this.step = step;
	},

	// Ajoute une classe d'animation CSS ponctuelle (keyframes definies dans
	// _ophorus_cmd_structure.scss) et la retire proprement a la fin, sans
	// setTimeout arbitraire.
	playMicroAnim(el, className) {
		if (!el) return;
		el.classList.remove(className);
		// force reflow pour permettre de rejouer l'animation si la classe
		// etait deja presente (rare, mais evite un no-op silencieux).
		void el.offsetWidth;
		el.classList.add(className);
		el.addEventListener("animationend", () => el.classList.remove(className), {once: true});
	},

	// Recalcule le resume compact affiche une fois la section repliee, a
	// partir des valeurs actuellement saisies dans son formulaire - aucune
	// donnee n'est effacee, seule cette ligne de recap est mise a jour.
	refreshStepSummary($section) {
		if ($section.find("[data-step-billing=true]").length) {
			$section.find(".__step_summary").text(this.buildContactSummary());
		} else if ($section.find("[data-step-infos=true]").length) {
			$section.find(".__step_summary").text(this.buildInfosSummary());
		}
	},

	buildContactSummary() {
		const name = ($("input[name=contact_principal_name]").val() || "").toString().trim();
		const lastname = ($("input[name=contact_principal_lastname]").val() || "").toString().trim();
		const email = ($("input[name=contact_principal_email]").val() || "").toString().trim();
		const fullName = `${name} ${lastname}`.trim();
		return [fullName, email].filter(Boolean).join(" · ") || "Contact details saved";
	},

	buildInfosSummary() {
		const parts = [];
		$(".__content_detail[data-step-infos=true] [name^='booking_field']").each(function () {
			const $el = $(this);
			const id = $el.attr("id");
			const $label = id ? $(`label[for='${id}']`) : $el.closest(".col-12").find("label").first();
			const labelText = $label.length ? $label.clone().children("small").remove().end().text().trim() : "";
			let value = "";
			if ($el.is(":checkbox")) {
				value = $el.prop("checked") ? "Yes" : "";
			} else {
				value = ($el.val() || "").toString().trim();
			}
			if (value) parts.push(labelText ? `${labelText}: ${value}` : value);
		});
		const comment = $("#_p_field_comment").val();
		if (comment && comment.toString().trim()) parts.push("Special request added");
		return parts.length ? parts.join(" · ") : "No additional details provided";
	},

	// Marque la section en erreur (ETAT ERROR), la garde ouverte, scrolle et
	// place le focus clavier sur le premier champ invalide.
	markStepError($section, $firstInvalidField) {
		$section.addClass("_error");
		if ($firstInvalidField && $firstInvalidField.length) {
			gsap.to(window, {
				duration: .8,
				scrollTo: {y: $section, offsetY: 100},
				onComplete: () => $firstInvalidField.trigger("focus")
			});
		}
	},

	// Peuple le select Country a partir des donnees deja embarquees par
	// intl-tel-input (meme source que le selecteur d'indicatif telephonique,
	// pas de liste pays maintenue en double cote PHP). data-value porte la
	// valeur eventuellement deja enregistree (contact_principal_country) ;
	// les anciennes valeurs saisies en texte libre avant ce changement ne
	// correspondront a aucun code ISO-2 et laisseront simplement le select
	// vide plutot que de planter.
	buildCountrySelect() {
		const $select = $("#_p_country");
		if (!$select.length) return;

		const current = ($select.data("value") || "").toString().toUpperCase();
		const entries = Object.entries(countryNames).sort((a, b) => a[1].localeCompare(b[1]));

		entries.forEach(([iso2, name]) => {
			const $option = $("<option>").val(iso2.toUpperCase()).text(name);
			if (iso2.toUpperCase() === current) $option.prop("selected", true);
			$select.append($option);
		});

		// "containerCssClass" n'existe plus dans select2 4.x (verifie dans
		// node_modules/select2/dist/js/select2.full.js - seule "dropdownCssClass"
		// est geree). Le CSS cible donc le container via le selecteur de
		// voisin "#_p_country + .select2-container" (select2 l'insere toujours
		// juste apres le <select> d'origine, cf. insertAfter dans la meme lib),
		// qui ne depend d'aucune option JS.
		$select.select2({
			placeholder: "Select a country",
			allowClear: true,
			width: "100%",
			dropdownAutoWidth: false,
			dropdownCssClass: "__country_select2_dropdown"
		});
	},

	checkBilling() {
		const $scope = $(".__content_detail[data-step-billing=true]");
		const $section = $scope.closest("._section_cmd");
		$section.removeClass("_error");
		$scope.find("._error_msg").remove();
		$scope.find("input").removeClass("_error_required");

		let _validate = true;
		let $firstInvalid = null;
		$scope.find("input[required]").each(function () {
			let invalid = false;
			if (!$(this).val()) {
				invalid = true;
				$(this).parent().append("<div class='_error_msg'>This field is required</div>");
			} else if ($(this).prop("type") === "email" && !cmd.isMail($(this).val())) {
				invalid = true;
				$(this).parent().append("<div class='_error_msg'>This email is not valid</div>");
			}
			if (invalid) {
				_validate = false;
				$(this).addClass("_error_required");
				if (!$firstInvalid) $firstInvalid = $(this);
			}
		});

		if (_validate) {
			$("input[name=contact_principal_phone]").val(this.iti.getNumber());
			const fields = $scope.find("input, select").serialize();
			$.post(_SITE_URL + 'save-cmd', {fields});
		} else {
			this.markStepError($section, $firstInvalid);
		}
		return _validate;
	},

	checkInfos() {
		const $scope = $(".__content_detail[data-step-infos=true]");
		const $section = $scope.closest("._section_cmd");
		$section.removeClass("_error");
		$scope.find("._error_msg").remove();
		$scope.find("input, select, textarea").removeClass("_error_required");

		let _validate = true;
		let $firstInvalid = null;
		$scope.find("input,select,textarea").each(function () {
			let invalid = false;
			if ($(this).prop("required") && (!$(this).val() || $(this).prop("type") === "checkbox" && !$(this).prop("checked"))) {
				invalid = true;
				$(this).parent().append("<div class='_error_msg'>This field is required</div>");
			} else if ($(this).prop("type") === "email" && !cmd.isMail($(this).val())) {
				invalid = true;
				$(this).parent().append("<div class='_error_msg'>This email is not valid</div>");
			}
			if (invalid) {
				_validate = false;
				$(this).addClass("_error_required");
				if (!$firstInvalid) $firstInvalid = $(this);
			}
		});

		if (_validate) {
			this.save_cmd_infos();
		} else {
			this.markStepError($section, $firstInvalid);
		}
		return _validate;
	},

	checkavaibility() {
		$.post(_SITE_URL + 'check-avaibility', (response) => {
			if (response) {
				const obj = JSON.parse(response);
				obj.forEach(item => $(`.__prod[data-product='${item.product_id}']`).remove());
				$("._product_non_availables").css("display", "flex");
			}
		});
	},

	save_cmd_infos() {
		const fields = $(".__content_detail[data-step-infos=true] input,select,textarea").serialize();
		const email = $("input[name=contact_principal_email]").val();
		const name = $("input[name=contact_principal_name]").val();
		$.post(_SITE_URL + 'save-cmd-infos', {fields, email, name}, (response) => {
			$("input[name=random_sess]").val(response);
		});
	},

	isMail(mail) {
		return /^([a-zA-Z0-9_\.\-\+])+@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(mail);
	},

	isphone(number) {
		return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(number);
	}
};

export default cmd;
